import * as React from 'react';
import { useContext } from 'react';

import type { ValuePropositionItem } from 'bundles/browse-common/types/valueProposition';

type ValuePropositionContextType = {
  title: string;
  description?: string | null;
  valuePropositionItems?: ValuePropositionItem[];
  loading: boolean;
};

const ValuePropositionContext = React.createContext<ValuePropositionContextType | undefined>(undefined);

export const useValueProposition = () => {
  return useContext(ValuePropositionContext);
};

export default ValuePropositionContext;
